export const JOB_LABELS: Record<string, string> = {
  evaluate: "Plan one staff day", backfill: "Plan this location's window", nightly_replan: "Re-plan every location's window", daily_lookahead: "Re-plan every location's window",
  replan_location_day: "Re-plan one location day", directory_sync: "Sync owner directory",
  reconcile_managed_blocks: "Reconcile our blocks with Boulevard", preview: "Owner preview", smoke_test: "Smoke test",
  ensure_webhook: "Register Boulevard webhook",
};
export function jobLabel(type: string): string { return JOB_LABELS[type] ?? type; }

export const STATUS_TONE: Record<"queued" | "running" | "done" | "failed", "neutral" | "info" | "success" | "danger"> = { queued: "neutral", running: "info", done: "success", failed: "danger" };

const short = (v: unknown) => (typeof v === "string" ? v.slice(0, 8) : "");
export function describePayload(_type: string, p: Record<string, unknown>): string {
  const parts: string[] = [];
  if (typeof p.blvdId === "string") parts.push(`location ${short(p.blvdId)}`);
  if (typeof p.staffId === "string") parts.push(`staff ${short(p.staffId)}`);
  if (typeof p.date === "string") parts.push(p.date);
  if (parts.length === 0 && typeof p.requestedBy === "string") parts.push(`by ${p.requestedBy}`);
  return parts.join(" · ");
}
